import { forwardRef } from 'react';
import { jsxs, jsx } from 'react/jsx-runtime';

const SvgLinkedinOutlined = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId,
    ...props,
    children: [title ? /*#__PURE__*/jsx("title", {
      id: titleId,
      children: title
    }) : null, /*#__PURE__*/jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M4.683 6.365A1.682 1.682 0 1 1 4.68 3a1.682 1.682 0 0 1 .003 3.364M17 16.976h-2.899v-4.54c0-1.082-.02-2.475-1.507-2.475-1.511 0-1.741 1.18-1.741 2.397v4.618H7.955V7.641h2.781v1.275h.04c.387-.734 1.334-1.507 2.746-1.507C16.457 7.409 17 9.34 17 11.856zm-10.865 0H3.23V7.641h2.905z",
      clipRule: "evenodd"
    })]
  });
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLinkedinOutlined);
var ForwardRef$1 = ForwardRef;

export { ForwardRef$1 as default };
